import {Options} from "highcharts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class LineBase extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'scatter',
                inverted: true,
                marginRight: 40,
                marginLeft: 30,
                spacingBottom: 0,
                spacingTop: 10,
                width: 500,
                height: 250,
            },
            xAxis: {
                labels: {
                    enabled: false,
                },
                gridLineWidth: 2,
                gridLineDashStyle: "Dot",
                lineColor: '#ccc',
            },
            yAxis: {
                labels: {
                    style: {
                        "color": "black",
                        "fontSize": "12px"
                    }
                },
                min: 0,
                max: 100,
                tickInterval: 10,
                gridLineColor: '#ccc',
                tickPositions: [0, 1, 2, 3, 4, 5],
                opposite: true,
            },
            plotOptions: {
                scatter: {
                    lineWidth: 0,
                    borderWidth: 0,

                    marker: {
                        radius: 12
                    },
                },

                series: {
                    lineWidth: 0,
                    borderWidth: 0,
                }
            },
        };

        return super.mergeOptions(super.allChartOptions(), options);
    }
}
